import { useState } from 'react';

interface UseMockLoadingProps<T, K> {
  asyncFunction: (value: T) => Promise<K | void>;
}

function useMockLoading<T, K>({ asyncFunction }: UseMockLoadingProps<T, K>) {
  const [isLoading, setIsLoading] = useState(false);

  const handleAsyncFunction = async (data?: T) => {
    setIsLoading(true);

    try {
      return await asyncFunction(data as T);
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, handleAsyncFunction };
}

export default useMockLoading;
